<template>
  <div class="Farming" v-if="isLoadingIndustry">
    <div class="bg-grey-lightest">
      <section class="hero">
        <div class="hero__cover" v-if="industry.coverimage" :style="{ backgroundImage: `url('${ $filters.imageUrl(industry.coverimage.url) }')` }"></div>
        <div class="hero__content">
          <div class="hero__content__wrap">
            <h1 class="text-white font-bold">{{ industry.title | i18n }}</h1>
            <p class="whitespace-pre-wrap">{{ industry.intro | i18n}}</p>
            <span class="hero__btn btn-cta" @click="openContactForm"><div class="btn btn-solid btn-blue gradient-btn"><span>{{ isOwlNest ? $t('freeTrial') : $t('contactAndBuy') }}</span><i class="owl-direction-right"></i></div></span>
          </div>
        </div>
      </section>
      <section class="container py-48">
        <div class="mb-64">
          <h2>{{ $t('blockChainBenefits') }}</h2>
          <div class="categories__wrap">
            <div v-for="(feature, index) in industry.features" :key="index" class="categories__item__wrap flex">
              <div class="categories__item">
                <img v-if="feature.logo && feature.logo.url" :src="$filters.imageUrl(feature.logo.url)">
                <h4 class="capitalize">{{ feature.name | i18n }}</h4>
              </div>
            </div>
          </div>
        </div>
        <div>
          <h2>{{ $t('achieveMore') }}</h2>
          <div class="solution__wrap">
            <div class="solution__item" v-for="(solution, index) in industry.solutions" :key="index">
              <img v-if="solution.image && solution.image.url" :src="$filters.imageUrl(solution.image.url)">
              <div class="solution__item__content">
                <h4 class="capitalize">{{ solution.title | i18n }}</h4>
                <p>{{ solution.description | i18n }}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <component :is="priceTable"></component>
    <div>
      <section v-if="isCampaign" class="belt">
        <div class="container">
          <div class="belt__left">
            <h2 class="capitalize">{{ industry.campaign_title | i18n }}</h2>
            <p :style="industry.campaign_image ? 'max-width: 480px' : ''">{{ industry.campaign_description | i18n}}</p>
            <div
              class="flex"
              :class="{'justify-center md:justify-start': !industry.campaign_link}">
              <a v-if="industry.campaign_link" :href="industry.campaign_link" target="_blank"><div class="btn btn-ghost btn-blue capitalize">{{ industry.campaign_button_name | i18n }}<i class="owl-direction-right"></i></div></a>
              <span class="btn-cta" @click="openContactForm"><div class="btn btn-solid btn-blue gradient-btn capitalize"><span>{{ contactBtnText }}</span><i class="owl-direction-right"></i></div></span>
            </div>
          </div>
          <div class="belt__right" v-if="industry.campaign_image">
            <img v-if="industry.campaign_image" :src="$filters.imageUrl(industry.campaign_image.url)" alt="contact">
          </div>
        </div>
      </section>
    </div>
    <component :is="cases" :showcases="industry.showcases"></component>
    <div>
      <section v-if="industry.youtubeID || industry.video" class="container pt-32 pb-64">
        <div>
          <h2>{{ $t('spotlight') }}</h2>
          <div class="videoWrapper mt-16 mb-64">
            <iframe :src="`https://www.youtube.com/embed/${$filters.i18n(industry['YoutubeID-i18n'])}?modestbranding=1`" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
        </div>
        <template v-if="industry.id === 3 && show(hotelsGroup)">
          <h2>合作夥伴</h2>
          <div class="collapse-wrap mt-16">
            <div class="collapse-row" v-for="(area, index) in hotelsGroup" :key="index" :class="{'open': nowCollapse === index}">
              <div class="collapse-title" @click="collapseSwitch(index)"><i class="owl-direction-right"></i>{{ $t(index) }}</div>
              <div class="collapse-body">
                <component
                  :is="hotel.url ? 'a' : 'div'"
                  v-for="hotel in hotelsGroup[index]"
                  :key="hotel.id"
                  class="collapse-item"
                  :href="hotel.url || null"
                  :target="hotel.url ? '_blank' : null"
                  :disabled="!hotel.url">
                  <div>{{ hotel.hotel_name | i18n(hotel.name) }}</div>
                </component>
              </div>
            </div>
          </div>
        </template>
      </section>
    </div>
    <section class="belt bg-grey-lightest" :class="{'bg-white': !isCampaign}">
      <div class="container">
        <div class="belt__left flex flex-col justify-between">
          <div>
            <h2 v-t="'banner.title'">成為OBS的合作夥伴</h2>
            <p v-t="'banner.description'">立即註冊將有專人與您聯繫，為您打造客製化OBS服務</p>
          </div>
            <span class="inline-block mb-48 btn-cta" @click="openContactForm"><div class="btn btn-solid btn-blue belt-btn-rwd gradient-btn" style="width: 350px; max-width: 80%;"><span>{{ isOwlNest ? $t('freeTrial') : $t('contactAndBuy') }}</span><i class="owl-direction-right"></i></div></span>
        </div>
        <div class="belt__right">
          <img class="p-32" src="@/assets/contact.png" alt="contact">
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import gql from 'graphql-tag'
import _ from 'lodash'
import { mapGetters, mapActions } from 'vuex'
import API from '@/api/home.js'
// @ is an alias to /src

import AgriculturePriceTable from '@/views/Agriculture/priceTable'
import AgricultureCases from '@/views/Agriculture/cases'

export default {
  name: 'Industry',
  components: {
    AgriculturePriceTable,
    AgricultureCases
  },
  // apollo: {
  //   industryId: {
  //     query: gql`query industryId {
  //       industries {
  //         id
  //         name
  //       }
  //     }`,
  //     update: function (data) {
  //       return _.find(data.industries, industry => industry.name === this.$route.params.industry).id
  //     }
  //   },
  //   industry: {
  //     query: gql`query industry ($id: ID!) {
  //       industry(id: $id) {
  //         name
  //         intro
  //         cover_image {
  //           url
  //         }
  //         features {
  //           name
  //           logo {
  //             url
  //           }
  //         }
  //         solutions {
  //           cover_image {
  //             url
  //           }
  //           name
  //           description
  //         }
  //         campaign_title
  //         campaign_description
  //         campaign_button_name
  //         campaign_link
  //         campaign_image {
  //           url
  //         }
  //         video
  //         youtubeID
  //       }
  //     }`,
  //     variables () {
  //       return {
  //         id: this.industryId
  //       }
  //     }
  //     // loadingKey: 'isLoadingIndustry',
  //     // watchLoading (isLoading, countModifier) {
  //     //   this.isLoadingIndustry = isLoading
  //     // }
  //     // pollInterval: 300
  //   }
  // },
  data () {
    return {
      // industryId: 0,
      // industry: {},
      nowCollapse: 'northern',
      hotels: []
    }
  },
  computed: {
    ...mapGetters([
      'routerNames',
      'industry',
      'solutions',
      'lang'
    ]),
    priceTable: function () {
      if (this.lang === 'jp') return false
      return this.industry.routername.name + 'PriceTable' || false
    },
    cases: function () {
      return this.industry.routername.name + 'Cases' || false
    },
    isCampaign: function () {
      return !_.isEmpty(this.industry.campaign_title) || !_.isEmpty(this.industry.campaign_description)
    },
    isLoadingIndustry: function () {
      return !_.isEmpty(this.industry)
      // return !this.$apollo.queries.industryId.loading && !this.$apollo.queries.industry.loading
    },
    hotelsGroup: function () {
      return _.groupBy(this.hotels, 'area')
    },
    isOwlNest: function () {
      return this.industry.routername.name === 'Travel-and-Hospitality'
    },
    contactBtnText: function () {
      if (this.industry.routername.name === 'Manufacturing') {
        return 'Buy and Download'
      } else if (this.isOwlNest) {
        return this.$t('freeTrial')
      } else {
        return this.$t('contactAndBuy')
      }
    }
  },
  methods: {
    ...mapActions([
      'fetchSolutions',
      'openContactForm'
    ]),
    show: function (key) {
      return !_.isEmpty(key)
    },
    collapseSwitch: function (index) {
      if (this.nowCollapse === index) {
        this.nowCollapse = ''
      } else {
        this.nowCollapse = index
      }
    }
  },
  mounted () {
    API.hotels().then(res => {
      this.hotels = res.data
    })
  }
}
</script>
<style lang="sass" scoped>
h2
  @apply text-grey-darkest font-bold

.hero
  &__btn
    .btn
      @apply w-full
      @screen sm
        @apply w-auto
  &__cover
    @apply flex-auto
  &__content
    @apply w-full
    @screen md
      @apply w-2/5

.categories
  &__wrap
    @apply flex flex-wrap
  &__item__wrap
    @apply w-1/2 p-8
    @screen md
      @apply w-1/3
    @screen lg
      @apply w-1/4
  &__item
    @apply shadow bg-white p-16 rounded
    img
      @apply mb-16
    h4
      @apply text-center
.solution
  @apply flex
  &__wrap
    @screen md
      @apply flex
  &__item
    @apply mt-24 text-center w-full
    @screen md
      @apply w-1/3 flex-1 mx-8
    img
      @apply rounded w-full
      @screen md
        @apply w-full
    &__content
      @apply p-16 text-left
      h4
        @apply text-grey-darkest font-bold mb-8
      p
        @apply leading-normal text-grey-darker
.example-hotel
  @apply pt-24 pb-64
  &__hero
    @apply mb-4
    img
      @apply w-full
  &__images
    @apply w-full
    @apply flex flex-wrap
    img
      @apply w-full mb-8
      @screen md
        @apply w-1/3 px-4

.collapse
  &-wrap
    @apply w-full
  &-row
    @apply w-full
    &:first-child
      .collapse-title
        @apply rounded-t border-t
    &:last-child
      .collapse-body
        @apply border-b rounded-b
    &.open
      .collapse-title
        i
          @apply ease
          transform: rotate(90deg) scale(0.7)
      .collapse-body
        max-height: 800px
  &-title
    @apply text-grey-darker bg-grey-lighter px-8 py-16 pl-0 border-l border-r border-grey-light cursor-pointer
    &:hover
      @apply bg-grey-light
    .owl-direction-right
      @apply inline-block text-grey-darker ml-8
      transform: scale(0.7)
  &-body
    @apply border border-grey-light flex flex-wrap overflow-hidden p-0
    transition: max-height .3s ease-in
    max-height: 0
  &-item
    @apply w-1/3 p-16 inline-block text-grey-darker no-underline
    .icon
      @apply text-blue
    &[disabled]
      @apply cursor-default
      .icon
        @apply hidden
    &:hover:not([disabled])
      @apply bg-grey-lighter
</style>
